window.scrollToClick = (function() {
	function getSectionsOffset(section, sections) {
		var nav = document.querySelector('.spy-nav');
		var navHeight = nav ? nav.offsetHeight : 0;

		Array.prototype.forEach.call(section, function(e) {
			sections[e.id] = window.scrollY + e.getBoundingClientRect().top - navHeight - 16;
		});
	}

	function spyBtnClick() {
		var buttons = document.querySelectorAll('[data-spy]');
		var buttonDataID = this.getAttribute('data-spy');
		var sectionOffsetTop = window.scrollY + document.getElementById(buttonDataID).getBoundingClientRect().top;
		var nav = document.querySelector('.spy-nav');
		var navHeight = nav ? nav.offsetHeight : 0;
		var offsetTop = sectionOffsetTop - navHeight - 16;

		Array.prototype.forEach.call(buttons, function(btn) {
			btn.classList.remove('active');
		});

		scrollToClick.isButtonClicked = true;
		this.classList.add('active');

		scroll({
			top: offsetTop,
			behavior: 'smooth'
		});
	}

	function spyResize() {
		var section = document.querySelectorAll('.spy-section');
		var sections = {};

		if (scrollToClick.hasResizedWindow) window.cancelAnimationFrame(scrollToClick.hasResizedWindow);

		scrollToClick.hasResizedWindow = window.requestAnimationFrame(function() {
			getSectionsOffset(section, sections);
			scrollToClick.hasResizedWindow = false;
		});
	}

	function spyScroll() {
		// If a spy button has been clicked, don't run scroll event
		if (scrollToClick.isButtonClicked) {
			clearTimeout(scrollToClick.isButtonClicked);
			scrollToClick.isButtonClicked = setTimeout(function() {
				scrollToClick.isButtonClicked = false;
			}, 66);

			return;
		}

		var scrollTimeout;
		var section = document.querySelectorAll('.spy-section');
		var sections = {};

		getSectionsOffset(section, sections);

		// If there's a timer, cancel it
		if (scrollTimeout) window.cancelAnimationFrame(scrollTimeout);

		// Setup the new requestAnimationFrame()
		scrollTimeout = window.requestAnimationFrame(function() {
			if (document.querySelector('.active')) {
				document.querySelector('.active').classList.remove('active');
			}
		});
	}

	return {
		isButtonClicked: false,
		hasResizedWindow: false,
		load: function() {
			var buttons = document.querySelectorAll('[data-spy]');

			buttons.forEach(button => {
				button.addEventListener('click', spyBtnClick);
			});

			window.addEventListener('scroll', spyScroll);
			window.addEventListener('resize', spyResize);
		},
		unload: function() {
			var buttons = document.querySelectorAll('[data-spy]');

			buttons.forEach(button => {
				button.removeEventListener('click', spyBtnClick);
			});

			window.removeEventListener('scroll', spyScroll);
			window.removeEventListener('resize', spyResize);
		}
	};
})();
